import { Component, Input, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MenuIconTypes } from '../dynamic-menu-icon/dynamic-menu-icon.component';

@Component({
  selector: 'bepatient-menu-secondary-button',
  templateUrl: './menu-secondary-button.component.html',
  styleUrls: ['./menu-secondary-button.component.scss'],
  standalone: false
})
export class MenuSecondaryButtonComponent {
  private sanitizer = inject(DomSanitizer);

  @Input() label: string;
  @Input() icon: MenuIconTypes;
  @Input() color = 'var(--ion-color-dark)';
  @Input() selected: boolean;

  defaultColor = this.sanitizer.bypassSecurityTrustStyle(
    'var(--ion-color-dark)'
  );
}
